const ScopeNotice = ({
  coverage = {},
  completePortfolioScope,
  partialPoolingGroupIds = [],
}) => {
  const multipleEntities = coverage.representedLegalEntityCount > 1;
  const partial = completePortfolioScope === false;
  if (!multipleEntities && !partial) return null;
  return <aside className="director-scope-notice" aria-label="Limites do recorte">
    {multipleEntities && <p>
      <strong>Soma de movimentos.</strong> As entradas e saídas de múltiplas entidades são somadas para leitura executiva; isso não indica transferência de dinheiro entre elas.
    </p>}
    {partial && <p>
      <strong>Escopo contratado.</strong> Este recorte segue somente as obras contratadas para a Diretoria.
      {Array.isArray(partialPoolingGroupIds) && partialPoolingGroupIds.length > 0
        ? ` Há ${partialPoolingGroupIds.length} grupo${partialPoolingGroupIds.length === 1 ? "" : "s"} de caixa com cobertura parcial.`
        : ""}
    </p>}
  </aside>;
};

export default ScopeNotice;
